/* eslint-disable new-cap */
import React from "react";
import * as ReactDOMServer from "react-dom/server";
import L from "leaflet";

const getMapIcon = () => {
  return new L.divIcon({
    html: ReactDOMServer.renderToString(
      <div className="relative cursor-default">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          fill="none"
          viewBox="0 0 64 64"
        >
          <circle cx="30" cy="30" r="24" fill="#60AF8C" opacity="0.2" />
          <g filter="url(#filter0_d_15801_269012)">
            <rect width="48" height="48" x="6" y="6" fill="#60AF8C" rx="24" />
          </g>
          <path
            stroke="#FAFAFA"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            d="m39 36-1-6h-3m4 6a2 2 0 0 0-2 2m2-2a2 2 0 1 1-2 2m0 0H27m0 0c0-1.1-.9-2-2-2s-2 .9-2 2m4 0a2 2 0 1 1-4 0m0 0h-4v-6m0 0h11c1.1 0 2-.9 2-2v-7h-3 9m-19 9v-4"
          />
          <defs>
            <filter
              id="filter0_d_15801_269012"
              width="64"
              height="64"
              x="0"
              y="0"
              colorInterpolationFilters="sRGB"
              filterUnits="userSpaceOnUse"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                result="hardAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dx="2" dy="2" />
              <feGaussianBlur stdDeviation="4" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
              <feBlend
                in2="BackgroundImageFix"
                result="effect1_dropShadow_15801_269012"
              />
              <feBlend
                in="SourceGraphic"
                in2="effect1_dropShadow_15801_269012"
                result="shape"
              />
            </filter>
          </defs>
        </svg>{" "}
      </div>,
    ),
  });
};

export default getMapIcon;
